import React from 'react';
import MacroContainer from './components/MacroContainer';

/**
 * Main export for the Macros feature
 * This component handles conversation analysis macros and user-defined macros
 */
const Macros = () => {
  return <MacroContainer />;
};

export default Macros; 